import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=5bbe5f1a&scoped=true&"
import script from "./AddProfile.vue?vue&type=script&lang=ts&"
export * from "./AddProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AddProfile.vue?vue&type=style&index=0&id=5bbe5f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe5f1a",
  null
  
)

export default component.exports